import { render } from "./ModalWithdrawUsdt.vue?vue&type=template&id=8b814e2a&scoped=true&ts=true"
import script from "./ModalWithdrawUsdt.vue?vue&type=script&lang=ts"
export * from "./ModalWithdrawUsdt.vue?vue&type=script&lang=ts"

import "./ModalWithdrawUsdt.vue?vue&type=style&index=0&id=8b814e2a&lang=stylus&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b814e2a"]])

export default __exports__